import { SwiperSlide } from 'swiper/react';
import useLadyService from '../../services/LadyService';
import { Button, ButtonLink, Icon } from '../ui';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Popup, RemoveStory } from '../popups';
import { getStoriesStatus, setStoriesStatus } from '@/stores/slices/popupSlice';
import { useDispatch, useSelector } from 'react-redux';

const StoriesComponentEdit = ({ setStories, setOpen, open, status, data, openAddStory }) => {
	const {
		id = data?.id,
		slug = data?.slug,
		name = data?.name,
		is_online = data?.is_online,
		age = data?.age,
		description = data?.description,
		created_at,
	} = data?.[0] || data;
	const { t, setMediaSize, TimeAgo } = useLadyService();
	const [timeAgo, setTimeAgo] = useState('');
	const regex = /([^.]+)$/;

	const dispatch = useDispatch();

	const storiesStatus = useSelector(getStoriesStatus);
	const handleClose = () => {
		dispatch(setStoriesStatus(false));
	};

	const res = data?.[0]?.media?.[0] ?? data?.media?.[0];

	const type = res?.match(regex)[1];

	const [muted, setMuted] = useState(false);
	const [remove, setRemove] = useState(false);

	const openRemoveButton = () => {
		setRemove(true);
	};

	return (
		<>
			<Popup
				wrapperClazz="stories-popup"
				open={setOpen ? open : storiesStatus}
				setOpen={setOpen ? setOpen : handleClose}
				container={'none'}
			>
				<SwiperSlide
					className={'stories__slide'}
					onClick={(e) => e.stopPropagation()}
				>
					<div className={'stories__card'}>
						{openAddStory &&
							<Button clazz='button btn--green add-story button--green' square={true} onClick={openAddStory}>
								<Icon
									size={'s'}
									spritePath={'plus-1'}
								/>
								{t('addstory')}
							</Button>}

						{type === ('mp4' || 'webm') && (
							<Button
								square={true}
								size={'s'}
								clazz={`stories__sound${muted ? ' _active' : ''}`}
								onClick={() => setMuted((state) => !state)}
							>
								<Icon
									size={'l'}
									spritePath={muted ? 'volume-x' : 'volume'}
								/>
							</Button>
						)}

						{status && (
							<Button
								square={true}
								size={'s'}
								clazz={`girl-card__remove button--secondary`}
								onClick={openRemoveButton}
							>
								<Icon
									size={'xl'}
									spritePath={'trash'}
									clazz={'_red'}
								/>
							</Button>
						)}

						{type === ('mp4' || 'webm') ? (
							<video
								loop={true}
								playsInline={true}
								autoPlay={true}
								muted={muted}
								src={res}
							/>
						) : (
							<img
								src={setMediaSize(res, 'xl')}
								alt={`${t('escortmodel')} ${name}`}
							/>
						)}

						{description ? (
							<p className="stories__text color-white">
								{description}
							</p>
						) : null}

						<div className="girl-card__info-wrapper">
							<div className="girl-card__age color-white">
								{age} <span>{t('years')}</span>
							</div>

							<div className="girl-card__info color-white">
								{is_online && (
									<Link
										title={name}
										className={`model__name${is_online ? ' _online' : ' _offline'
											}`}
									>
										{name}
									</Link>
								)}
								{created_at && (
									<p className={'color-white'}>
										<TimeAgo
											setTimeAgo={setTimeAgo}
											timeAgo={timeAgo}
											timestamp={created_at}
										/>
									</p>
								)}
							</div>

							<ButtonLink
								size={'m'}
								href={`/profile/${slug}`}
								clazz={'button--green _no-underline'}
								onClick={() => setOpen(false)}
							>
								{t('seead')}
								<Icon
									spritePath={'chevrone-right'}
									size={'m'}
								/>
							</ButtonLink>
						</div>
					</div>
				</SwiperSlide>
			</Popup>

			{remove && (
				<RemoveStory
					open={remove}
					setOpen={setRemove}
					id={id}
					setStories={setStories}
					setOpenAll={setOpen}
				/>
			)}
		</>
	);
};

export default StoriesComponentEdit;
